import Model from '@/entities/Model.js';

export default class Campaign extends Model {
    static get defaults() {
        return {
            name: null,
        };
    }

    isValid() {
        return !!this.name;
    }
}
